import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Box } from '@material-ui/core'
import M_ButtonNormal from 'components/1_Atoms/2_Molecules/M_ButtonNormal'
import Grid from '@material-ui/core/Grid'
import { buttonInfo } from 'types/FunctionTypes'

const useStyles = makeStyles({
  root: {
    width: '100%',
  },
})
const margin = 0
const paddingX = 0.5
const paddingY = 0

type Props = {
  buttonInfos: buttonInfo[]
  buttonClose: buttonInfo
}

const O_FooterModal = ({ buttonInfos, buttonClose }: Props) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <Grid container justifyContent="flex-start" spacing={1}>
        <Grid item xs={11}>
          {buttonInfos.map((buttonInfo) => {
            return (
              <Box m={margin} px={paddingX} py={paddingY}>
                <M_ButtonNormal
                  label={buttonInfo.label} //
                  event={buttonInfo.click}
                  disabled={buttonInfo.disabled}
                  alert={buttonInfo.alert}
                />
              </Box>
            )
          })}
        </Grid>
        <Grid item xs={1}>
          <Grid container justifyContent="flex-end">
            <M_ButtonNormal label={buttonClose.label} event={buttonClose.click} disabled={buttonClose.disabled} />
          </Grid>
        </Grid>
      </Grid>
    </div>
  )
}
export default React.memo(O_FooterModal)
